import { BinaryWriter } from "../binary.js";
import { ServerOp } from "../opcodes.js";
export function encodeDespawn(packet, writer = new BinaryWriter(4 + packet.ids.length * 4)) {
    writer.u8(ServerOp.Despawn).u16(packet.ids.length);
    for (const id of packet.ids)
        writer.u32(id);
    return writer;
}
export function decodeDespawn(reader) {
    const count = reader.u16();
    const ids = new Array(count);
    for (let i = 0; i < count; i++)
        ids[i] = reader.u32();
    return { ids };
}
//# sourceMappingURL=despawn.js.map